var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 512 512","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('ellipse',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1","cx":"256","cy":"256","rx":_vm.rX,"ry":"256","vector-effect":"non-scaling-stroke"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }